import { useMemo } from 'react'
import { resolveVariant, resolveChartVariant } from '../styleVariants'

function normalize (variant, resolvedOverrides) {
  const ov = resolvedOverrides ?? variant?.overrides ?? {}
  const s = ov.styles ?? {}
  return {
    variantCode: variant?.code ?? 'default',
    displayName: variant?.displayName ?? 'Default',
    props: ov.props ?? {},
    className: ov.className ?? null,
    tableClassName: ov.tableClassName ?? null,
    styles: Object.keys(s).length ? s : undefined
  }
}

function resolveWithParams (variant, config) {
  if (typeof variant?.resolve === 'function') {
    const defaults = Object.fromEntries(
      (variant.parameters ?? []).map(p => [p.key, p.default])
    )
    const merged = { ...defaults, ...(config?.styleVariantParams ?? {}) }
    return normalize(variant, variant.resolve(merged))
  }
  return normalize(variant)
}

export default function useStyleVariant (presentationType, config) {
  const styleVariant = config?.styleVariant
  const styleVariantParams = config?.styleVariantParams
  return useMemo(() => {
    const variantCode = styleVariant ?? 'default'
    const variant = resolveVariant(presentationType, variantCode)
    return resolveWithParams(variant, { styleVariant, styleVariantParams })
  }, [presentationType, styleVariant, styleVariantParams])
}

export function useChartStyleVariant (layout, config) {
  const styleVariant = config?.styleVariant
  const styleVariantParams = config?.styleVariantParams
  return useMemo(() => {
    const variantCode = styleVariant ?? 'default'
    const variant = resolveChartVariant(layout, variantCode)
    return resolveWithParams(variant, { styleVariant, styleVariantParams })
  }, [layout, styleVariant, styleVariantParams])
}
